/**
 * Dónde pasó, para el panel de la campana: «Nombre de la fila» (Base › Tabla).
 *
 * El mismo formato que el correo, que lo arma `ExtractoMixin.donde` en el
 * backend. Están duplicados porque el correo se compone en el servidor y este
 * panel en el navegador; si cambia uno hay que cambiar el otro.
 *
 * Va la base además de la tabla porque en esta instancia los nombres de tabla se
 * repiten —hay dos "COMPRAS OTROS DEPARTAMENTOS"— y sin la base no se distingue
 * cuál es.
 */
export function donde(datos) {
  const nombre = (datos.row_name || '').trim()
  // `row_name` no existía cuando se crearon los primeros avisos, y esos siguen
  // en la base: sin este respaldo el panel los pintaría con «» vacías.
  const fila = nombre ? `«${nombre}»` : `la fila ${datos.row_id}`
  const ubicacion = [datos.database_name, datos.table_name]
    .filter((x) => x)
    .join(' › ')
  return ubicacion ? `${fila} (${ubicacion})` : fila
}
